import Service from './Service';

const DIALOG_SHOW = 'DIALOG_SHOW';
const reducerName = 'dialog';

const initialState = {
    id: null,
    data: null
};

const reducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case DIALOG_SHOW: {
            const {id, data, callback} = payload;
            return {id, data, callback};
        }
    }
    return state;
};

class DialogService extends Service {
    constructor() {
        super();

        if (!DialogService.instance) {
            DialogService.instance = this;
        }
        return DialogService.instance;
    }

    getReducerName() {
        return reducerName;
    }

    getReducer() {
        return reducer;
    }

    show(id, data, callback) {
        this.store.dispatch({
            type: DIALOG_SHOW,
            payload: {
                id,
                data,
                callback
            }
        });
    }
}

export default new DialogService();
